// Webpack will replace 'environment-node' with 'environment-browser' in browser environments.
module.exports = require('./environment-node');
